"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require('classnames');
var styles = require('./OptionDescription.scss');
function OptionDescription(props) {
    return (React.createElement("p", tslib_1.__assign({}, props, { className: classNames(props.className, styles.description) }), props.children));
}
exports.default = OptionDescription;
//# sourceMappingURL=OptionDescription.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/view/owa-options-controls/lib/components/OptionDescription.js
// module id = 4931
// module chunks = 2